import './Skeleton.css';

type SkeletonProps = {
    width?: string;
    height?: string;
    borderRadius?: string;
    className?: string;
};

export function Skeleton({ width = '100%', height = '16px', borderRadius = '8px', className = '' }: SkeletonProps) {
    return (
        <div
            className={`skeleton ${className}`}
            style={{ width, height, borderRadius }}
        />
    );
}

/** Card-shaped skeleton for grids (networking, education) */
export function SkeletonCard() {
    return (
        <div className="skeleton-card">
            <div className="skeleton-card-header">
                <Skeleton width="48px" height="48px" borderRadius="50%" />
                <div className="skeleton-card-info">
                    <Skeleton width="60%" height="14px" />
                    <Skeleton width="40%" height="12px" />
                </div>
            </div>
            <Skeleton width="100%" height="12px" />
            <Skeleton width="80%" height="12px" />
        </div>
    );
}

/** Message-shaped skeleton for chat loading */
export function SkeletonMessage({ align = 'left' }: { align?: 'left' | 'right' }) {
    return (
        <div className={`skeleton-message ${align}`}>
            <Skeleton
                width={align === 'right' ? '45%' : '65%'}
                height="48px"
                borderRadius={align === 'right' ? '18px 18px 4px 18px' : '4px 18px 18px 18px'}
            />
        </div>
    );
}

/** Profile field skeleton */
export function SkeletonField() {
    return (
        <div className="skeleton-field">
            <Skeleton width="30%" height="12px" />
            <Skeleton width="100%" height="40px" borderRadius="10px" />
        </div>
    );
}
